import { type HTMLAttributes } from 'react';
import { clsx } from 'clsx';
import styles from './Card.module.css';

export type CardProps = HTMLAttributes<HTMLDivElement>;

export function Card({ className, children, ...rest }: CardProps) {
  return (
    <div className={clsx(styles.card, className)} {...rest}>
      {children}
    </div>
  );
}
